import { ChevronLeft, ChevronRight } from 'lucide-react';
import { startOfWeek, endOfWeek, addWeeks, subWeeks, format } from 'date-fns';

interface WeekNavigationProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
}

export function WeekNavigation({ selectedDate, onDateChange }: WeekNavigationProps) {
  const current = new Date(selectedDate + 'T12:00:00');
  const weekStart = startOfWeek(current, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(current, { weekStartsOn: 1 });

  const rangeLabel = `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d, yyyy')}`;

  const goToPreviousWeek = () => {
    const prev = subWeeks(current, 1);
    onDateChange(format(prev, 'yyyy-MM-dd'));
  };

  const goToNextWeek = () => {
    const next = addWeeks(current, 1);
    onDateChange(format(next, 'yyyy-MM-dd'));
  };

  const goToToday = () => {
    onDateChange(format(new Date(), 'yyyy-MM-dd'));
  };

  return (
    <div className="flex items-center justify-between bg-bg-secondary rounded-lg p-3 mb-4">
      <button
        onClick={goToPreviousWeek}
        className="p-1.5 rounded-md hover:bg-bg-tertiary transition-colors text-text-secondary hover:text-text-primary"
        aria-label="Previous week"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>

      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-text-primary">{rangeLabel}</span>
        <button
          onClick={goToToday}
          className="px-3 py-1 text-xs font-medium rounded-md bg-accent-purple/15 text-accent-purple hover:bg-accent-purple/25 transition-colors"
        >
          Today
        </button>
      </div>

      <button
        onClick={goToNextWeek}
        className="p-1.5 rounded-md hover:bg-bg-tertiary transition-colors text-text-secondary hover:text-text-primary"
        aria-label="Next week"
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  );
}

export default WeekNavigation;
